<template>
  <div>
    <b-list-group>
      <transition-group name="bounce">
        <b-list-group-item 
          v-for="record in records"
          :key="record.id"
          class="flex-column align-items-start mb-2 main-column"
        >
          <div
            class="d-flex w-100 justify-content-between align-items-center reference"
            @click="toggleChildren(record.id)"
          >
            <span 
              :class="level <= 2 ? 'cursor-pointer font-weight-bold' : 'cursor-pointer'"
            >ID: {{ record.id }}, {{ record.name }} ({{ record.unit }}<template v-if="record.external_number">, {{ record.external_number }}</template>)</span>
            <div class="d-flex align-items-center">
                <!-- <i class="bx bxs-trash cursor-pointer mr-2" v-if="!record.properties.length" @click="toTrashDictionaryElement(record.id)"></i> -->
                <!-- <i class="bx bx-add-to-queue cursor-pointer mr-2" @click="addSubElement[record.id] = !addSubElement[record.id]"></i> -->
                <i class="bx bx-edit cursor-pointer mr-2" @click.stop="showEditDictionaryElementInput(record.id)"></i>
                <b-badge :variant="record.children.length > 0 ? 'primary' : 'secondary'" pill>{{ record.children.length }}</b-badge>
            </div>
          </div>

          <div
            v-if="record.children && record.children.length > 0"
            class="properties mt-3"
            v-show="showChildren.hasOwnProperty(record.id) ? showChildren[record.id] : false"
          >        
            <NestedRecords 
              :records="record.children"
              :level="level+1"
              :unitOptions="unitOptions"
              :parentOptions="parentOptions"
            />
          </div>

        </b-list-group-item>
      </transition-group>
    </b-list-group>
    <BdrDictionarySidebar
      :isOpen.sync='isOpen'
      :editedItem.sync="editedItem"
      :unitOptions="unitOptions"
      :parentOptions="parentOptions"
      @updateItem="updateItem"
    ></BdrDictionarySidebar>
  </div>
</template>

<script>
import NestedRecords from '@/components/bdrPage/BdrNestedRecords';
import BdrDictionarySidebar from '@/components/bdrPage/BdrDictionarySidebar';

const initialDictionaryElement = () => (
    {
      name: '',
      unit: 'B2C',
      external_number: '',
      parent_id: 0
    }
);

export default {
  name: 'NestedRecords',
  props: {
    records: {
      type: Array,
      required: true
    },
    level: {
      type: Number,
      required: true
    },
    unitOptions: {
      type: Array,
      required: true
    },
    parentOptions: {
      type: Array,
      required: true
    },

  },
  components: {
    NestedRecords,
    BdrDictionarySidebar
  },
  watch: {
    records: {
        deep: true,
        handler(records) {
          records.forEach(record => {
            this.$set(this.showChildren, record.id, false)
          });
        },
    }, 
  },  
  data() {
    return {
      showChildren: {},
      editedItem: {
        id: '',
        name: '',
        unit: 'B2C',
        external_number: '',
        parent_id: 0,
      },
      isOpen: false
    }
  },
  methods: {
    toggleChildren(record_id) {
      if (this.showChildren.hasOwnProperty(record_id)) {
        this.showChildren[record_id] = !this.showChildren[record_id];
      } else {
        this.$set(this.showChildren, record_id, true);
      }
    },
    showEditDictionaryElementInput(record_id) {
      const record = this.records.find(record => record.id === record_id);

      this.editedItem = record === undefined ? initialDictionaryElement() : JSON.parse(JSON.stringify(record));
      this.isOpen = true;
    },
    updateItem(item) {
      const recordIndex = this.records.findIndex(record => record.id === item.id);

      if (recordIndex !== -1) {
        this.records[recordIndex] = JSON.parse(JSON.stringify(item));
      }
    },
    toTrashDictionaryElement(id) {
      axios
        .delete(`${API_BDR_DICTIONARY}/${id}`)
        .then((data) => {
          this.dictionary = this.dictionary.filter(item => item.id !== id)
      });
    },
  },  
}
</script>
